import { Col, Form, Row, } from "antd";
import { MazakaForm } from "apps/Common/MazakaForm";
import { addAdvertToAlarm, updateAlarm, } from "apps/RealState/Details/Services";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import useMazakaForm from "hooks/useMazakaForm";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { RootState } from "store/Reducers";
import { MazakaSelect } from "apps/Common/MazakaSelect";
import GeneralNotificationTypes from "apps/Common/NotificationTypes/GeneralNotificationTypes";
import { FC, useEffect } from "react";

const SelectAlarmWays:FC<{onFinish:any,selectedRecord?:any}> = ({onFinish,selectedRecord}) => {
  const [form] = Form.useForm();
  const { formActions, mazakaForm } = useMazakaForm(form);

  const [searchParams] = useSearchParams();
  const { userInfoes } = useSelector((state: RootState) => state.profile);
  const advertId = searchParams.get("id");


  useEffect(()=>{
form.setFieldValue("notificationTypeIdList",selectedRecord?.notificationTypeAlarm?.map((item:any)=>item.notificationTypeId))
  },[selectedRecord])

  console.log("se",selectedRecord)

  const handleOnFinish = async () => {
    mazakaForm.setLoading();
    let formValues = form.getFieldsValue();

    try {
    
      
      if(selectedRecord)
      {

        await updateAlarm({...selectedRecord,notificationTypeIdList:formValues["notificationTypeIdList"]})
      }
      else{
        const data = {
          advertId: advertId,
          userId: userInfoes.id,
          notificationTypeIdList: formValues["notificationTypeIdList"],
        };

        await addAdvertToAlarm(data);
      }
      mazakaForm.setSuccess(2000,()=>"İşlem Başarılı")
      onFinish()
    } catch (error: any) {
      mazakaForm.setFailed(2000,error?.message)
      openNotificationWithIcon("default", error?.message);
      console.log("somethings wrong wehen adding ad ad to favorite", error);
    }
  };
  return (
    <>
      <Col xs={24}>
        <MazakaForm initialValues={{alarmStatus:1}} form={form} onFinish={handleOnFinish} {...formActions} >
          <Row>
            <MazakaSelect
            label="Alarm Durumları"
            placeholder="Alarm Durumları"
            name={"alarmStatus"}
            options={[
              {label:"Fiyat değiştiğinde haber ver",value:1}
              ,{label:"İlan güncellendiğinde haber ver",value:2},
              {label:"İlan silindiğinde haber ver",value:3},
              {label:"İlan yeniden yayınlandığında haber ver",value:4},
            ]}
            xs={24}
            />
            <GeneralNotificationTypes
              xs={24}
              label="Alarm Yolları"
              placeholder="Alarm Yolları"
              name="notificationTypeIdList"
              mode="multiple"
            />
          </Row>
        </MazakaForm>
      </Col>
    </>
  );
};

export default SelectAlarmWays;
